import React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';

const StyledIcon = styled.svg`
    fill: #DBC7A7;
`;

const ExclamationCircle = () => {
  return (
    <StyledIcon xmlns="http://www.w3.org/2000/svg" width="10.946" height="10.946" viewBox="0 0 10.946 10.946">
      <defs></defs><path d="M13.473,8a5.473,5.473,0,1,0,5.473,5.473A5.474,5.474,0,0,0,13.473,8Zm0,2.428a.927.927,0,1,1-.927.927A.927.927,0,0,1,13.473,10.428Zm1.236,5.606a.265.265,0,0,1-.265.265H12.5a.265.265,0,0,1-.265-.265V15.5a.265.265,0,0,1,.265-.265h.265V13.826H12.5a.265.265,0,0,1-.265-.265v-.53a.265.265,0,0,1,.265-.265h1.412a.265.265,0,0,1,.265.265v2.207h.265a.265.265,0,0,1,.265.265Z" transform="translate(-8 -8)"/>
    </StyledIcon>
  )
}

export default ExclamationCircle;